import { navigateTo } from '@helpers';
import { OPERATOR_PANEL_INFORMATION_SCREENS, scheduledProductionOperationIdParam } from '@components/operatorPanel/constants/operatorPanel.constants';

import type { GoToJobScreenParams } from '@components/search/operations/components/StartJobPopup/types';

// Navigates to the job's screen in the Operator Panel and closes the modal.
export const goToJobScreen = ({ productionOperationId, machineId, hide }: GoToJobScreenParams) => {
  navigateTo(OPERATOR_PANEL_INFORMATION_SCREENS.Information, {
    screen: OPERATOR_PANEL_INFORMATION_SCREENS.Jobs,
    params: { [scheduledProductionOperationIdParam]: productionOperationId, id: machineId },
  });
  hide();
};
